import Checkbox from '$components/Forms/Checkbox'
import {
    MdFullscreen,
    MdFullscreenExit,
    MdOutlinePhotoSizeSelectActual,
    MdOutlinePhotoSizeSelectLarge,
} from 'react-icons/md'

const DocumentViewHeaderToolbar = ({
    isParseAdmin,
    isFullScreen,
    toggleFullScreen,
    hasAssignedLabels,
    showAllLabelsChecked,
    setShowAllLabelsChecked,
    showPrivateLabelsChecked,
    setShowPrivateLabelsChecked,
    showExpandedAnnotationView,
    setShowExpandedAnnotationView,
}) => {
    
    return (<>
        
        {hasAssignedLabels && (
            <Checkbox
                label="All Labels"
                labelRtl
                checked={showAllLabelsChecked}
                onChange={e => setShowAllLabelsChecked(e.target.checked)} />
        )}
        
        {isParseAdmin && (
            <Checkbox
                label="Private Labels"
                labelRtl
                labelProps={{
                    title: 'Show private labels (admins only)',
                }}
                checked={showPrivateLabelsChecked}
                onChange={e => setShowPrivateLabelsChecked(e.target.checked)} />
        )}
        
        <button
            className="btn btn-link p-0 ml-3 text-gray-400"
            onClick={() => setShowExpandedAnnotationView(!showExpandedAnnotationView)}>
            {showExpandedAnnotationView ? (
                <MdOutlinePhotoSizeSelectActual
                    className="text-2xl"
                    data-tooltip-id="default-tip"
                    data-tooltip-content="Zoom to fit vertically"/>
            ) : (
                <MdOutlinePhotoSizeSelectLarge
                    className="text-2xl"
                    data-tooltip-id="default-tip"
                    data-tooltip-content="Zoom to fit horizontally"/>
            )}
        </button>
        
        <button
            className="btn btn-link p-0 mr-3 text-gray-400"
            onClick={toggleFullScreen}>
            {isFullScreen ? (
                <MdFullscreenExit
                    className="text-2xl"
                    data-tooltip-id="default-tip"
                    data-tooltip-content="Fullscreen"/>
            ) : (
                <MdFullscreen
                    className="text-2xl"
                    data-tooltip-id="default-tip"
                    data-tooltip-content="Exit Fullscreen"/>
            )}
        </button>
    
    </>)
    
}

export default DocumentViewHeaderToolbar
